<script setup lang="ts">
import TzDisplay from '@Molecules/Auth/TzDisplay.vue'
import UserPanel from '@Molecules/Auth/UserPanel.vue'
import CurrentTime from '@Molecules/Auth/CurrentTime.vue'

defineOptions({
  name: 'AdminDropdown',
})

</script>

<template>
  <div
    class="adm-dropdown"
  >
    <div class="adm-dropdown__time">
      <TzDisplay />
      <CurrentTime />
    </div>
    <UserPanel />
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Molecules/Auth/AdminDropdown.scss" />
